import React from "react";
import { string, number, bool, oneOfType } from "prop-types";

import Image from "../Components/Image";

const SellerItem = ({
    logo_pic,
    shop_url,
    seller_id,
    shop_title,
    showDetails
}) => {
    return (
        <div
            title={shop_title}
            className="card card-hover seller-carousel-item">
            <div className="card-img-top">
                <a
                    className="bg-white"
                    href={`/sellers/profile/${shop_url}/${seller_id}`}>
                    <Image
                        src={`${localStorage.getItem(
                            "restUrl"
                        )}/pub/media/avatar/${logo_pic}`}
                    />
                </a>
            </div>
            {showDetails && (
                <div className="card-body p-2">
                    <h3 className="mb-0 font-weight-bold">{shop_title}</h3>
                </div>
            )}
        </div>
    );
};

SellerItem.defaultProps = {
    showDetails: true
};

SellerItem.propTypes = {
    shop_title: string,
    logo_pic: string,
    shop_url: string,
    seller_id: oneOfType([string, number]),
    showDetails: bool
};

export default SellerItem;
